import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ICreateGroupService, IGroupName, CreateGroupResult } from './groupOrderCreateGroup.facade';
import { InHouseOrderService } from '../../services/inHouseOrder.service';
import { Router } from "@angular/router";
import { ITableQRCode, GetPlaceStatus } from '../../services/IInHouseOrderService';
import { CoreLogService } from '../../services/log.service';
import { WebShopService } from '../../services/webShop.service';

@Injectable()
export class GroupOrderCreateGroupService implements ICreateGroupService, OnDestroy {

  // initial angegebene Daten
  private tableData: ITableQRCode = null;

  constructor(private _inHouseOrderService: InHouseOrderService
    , private _router: Router
    , private _coreLogService: CoreLogService
    , private _webShopService: WebShopService) {
  }

  ngOnDestroy(): void {
    // Führt Cleanup durch
    const me = this;
    me.releaseProposedGroupNames();
  }

  public async initial(tableQrCode: string): Promise<void> {
    const me = this;

    if (me.tableData != null)
      throw new Error("initial is called twice");

    me.tableData = await me._inHouseOrderService.GetTableQRCodeData(tableQrCode);

    if (me.tableData == null)
      throw new Error("wrong table code");

    const TableGroupInfo = await me._inHouseOrderService.GetTableGroupInfo(me.tableData.location, me.tableData.tableNr)

    me._setGroupExists(TableGroupInfo.table_has_groups);
    me._setCanCreateGroup(!TableGroupInfo.group_limit_reached);
    me._setProposedGroupNames(TableGroupInfo.group_names);
  }

  /** gibt die nicht genutzten Gruppennamen wieder frei (is asynchrone without waiting) */
  public releaseProposedGroupNames(): void {
    const me = this;
    if (me._proposedGroupNames.length > 0 && me.tableData != null) {
      me._inHouseOrderService.ReleaseGroupNames(me.tableData.location, me._proposedGroupNames.map((item) => item.name)); // not need to wait
      me._proposedGroupNames = [];
    }
  }

  private async _setProposedGroupNames(groupNames: string[]): Promise<void> {
    const me = this;
    me.releaseProposedGroupNames();

    me._proposedGroupNames = groupNames.map((name) => { return { name }; });
    me._proposedGroupNamesSubject.next(me._proposedGroupNames);
    me._hasProposedGroupNamesSubject.next(groupNames.length > 0);
  }
  /** use _setProposedGroupNames */
  private _proposedGroupNames: IGroupName[] = [];
  private _proposedGroupNamesSubject: BehaviorSubject<IGroupName[]> = new BehaviorSubject<IGroupName[]>([]);
  get proposedGroupNames$(): Observable<IGroupName[]> {
    return this._proposedGroupNamesSubject.asObservable();
  }

  private _hasProposedGroupNamesSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  /** proposed group names (portal*/
  public get hasProposedGroupNames$(): Observable<boolean> {
    return this._hasProposedGroupNamesSubject.asObservable();
  }

  /** use _setGroupExists */
  private _groupExists: boolean = false;
  /**the number of table groups is greater than 0
   * info if group exist join group button active 
  */
  private _setGroupExists(groupExists: boolean): void {
    const me = this;
    if (me._groupExists != groupExists) {
      me._groupExists = groupExists;
      me._groupExistsSubject.next(me._groupExists);
    }
  }
  /** the number of table groups is greater than 0 */
  private _groupExistsSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public get groupExists$(): Observable<boolean> {
    return this._groupExistsSubject.asObservable();
  }

  /** use _setCanCreateGroup */
  private _canCreateGroup: boolean = false;
  /** Group can be created (tgroup count of the table must be less than the max. allowed count)*/
  private _setCanCreateGroup(canCreateGroup: boolean): void {
    const me = this;
    if (me._canCreateGroup != canCreateGroup) {
      me._canCreateGroup = canCreateGroup;
      me._canCreateGroupSubject.next(me._canCreateGroup);
    }
  }
  /**can create group : group count on table is less then max Group count */
  private _canCreateGroupSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public get canCreateGroup$(): Observable<boolean> {
    return this._canCreateGroupSubject.asObservable();
  }

  public async createGroup(group_name: string, nickname: string): Promise<CreateGroupResult> {
    const me = this;

    // todo hier eventuell die GPS prüfung?

    let releaseNames = me._proposedGroupNames.map((item) => item.name);
    const usedNameIndex = releaseNames.indexOf(group_name);
    if (usedNameIndex > -1)
      releaseNames = releaseNames.splice(usedNameIndex, 1);

    const newGroup = await me._inHouseOrderService.CreateGroup(me.tableData.qrCode, group_name, releaseNames, nickname);
    if (newGroup.success) {
      return CreateGroupResult.Okay;
    } else {
      switch (newGroup.status) {
        case GetPlaceStatus.TableFull:
          return CreateGroupResult.TableFull;
        case GetPlaceStatus.WrongUserName:
          return CreateGroupResult.WrongUserName;
        case GetPlaceStatus.WrongGroupName:
          return CreateGroupResult.WrongGroupName;
        case GetPlaceStatus.Fail, GetPlaceStatus.Error:
          return CreateGroupResult.Fail;
        default:
          me._coreLogService.error("GroupOrderCreateGroupService.createGroup", "unknown status", newGroup.status);
          return CreateGroupResult.Fail;
      }
    }
  }
}